{
  "version": 1,
  "asset_id": "4e0ace45-c0d7-419d-b2b7-6541b1a83ba0",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/4e0ace45-c0d7-419d-b2b7-6541b1a83ba0/sleeve-amateur-3.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/4e0ace45-c0d7-419d-b2b7-6541b1a83ba0/sleeve-amateur-3.png",
  "original_filename": "sleeve-amateur-3.png",
  "size": 162966,
  "content_type": "image/jpeg",
  "created_at": "2026-07-14T23:06:46Z"
}
